(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["notice-modal"] && !Shopify.designMode) return;
  try {
    const NOTICE_MODAL_STORAGE_KEY = 'boujie_notice_modal_last_shown';

  const getLocalDateKey = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const hasShownNoticeToday = () => {
    try {
      return window.localStorage.getItem(NOTICE_MODAL_STORAGE_KEY) === getLocalDateKey();
    } catch (error) {
      return false;
    }
  };

  const markNoticeAsShown = () => {
    try {
      window.localStorage.setItem(NOTICE_MODAL_STORAGE_KEY, getLocalDateKey());
    } catch (error) {
      return false;
    }

    return true;
  };

  document.querySelectorAll('.notice-modal-component[data-open-on-load="true"]').forEach((component) => {
    const dialog = component.querySelector('dialog');
    if (!(dialog instanceof HTMLDialogElement)) return;

    if (!dialog.open && !hasShownNoticeToday()) {
      markNoticeAsShown();
      dialog.showModal();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
